if ($('#app-post-comscore-table').length) {

    var progress_loader_steps = 0;
    var progress_loader_curr_step = 0;
    var update_progress_loader = function (message, steps) {
        var container = $('#progressloader');

        progress_loader_curr_step++;
        width = (progress_loader_curr_step / progress_loader_steps) * 100;
        container.find('.progress-bar').attr('aria-valuenow', width).css('width', width.toString() + '%');
        if (steps === true) {
            message = message + ' (' + progress_loader_curr_step + ' of ' + progress_loader_steps + ')';
        }
        container.find('span').html(message + '...');
        if(progress_loader_steps <= progress_loader_curr_step)
            close_progress_loader();
    };

    var init_progress_loader = function (steps, message) {
        progress_loader_steps = steps;
        progress_loader_curr_step = 0;

        update_progress_loader(message);

        $('#progressloader').show();
    };

    var close_progress_loader = function () {
        progress_loader_steps = 0;
        progress_loader_curr_step = 0;
        $('#progressloader').hide();
    };

    var app_post_comscore_table = $('#app-post-comscore-table').DataTable({
        order: [6, "desc"],
        columns: [
            {data: 'id'},//0
            {data: 'name'},//1
            {data: 'advertiser_name'},//2
            {data: 'campaign_name'},//3
            {data: 'market_name'},//4
            {data: 'created_at'},//5
            {data: 'id'}//6
        ],
        destroy: true,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 0,
                "visible": false,
            },
            {
                "targets": 5,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    date = moment(cellData, "YYYY-MM-DD HH:mm:ss");
                    $(td).html(date.format('MM/DD/YYYY'));
                }
            },
            {
                "targets": 6,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                        '<a href="javascript:void(0)" role="button" class="btn btn-info btn-sm report-view" data-id="'+cellData+'">' +
                        '<i class="fa fa-eye"></i> View' +
                        '</a>' +
                        '<a href="/post/comscore/edit/configuration/' + cellData +' "  class="btn btn-success btn-sm btn-disabled edit-report " role="button">' +
                        '<i class="fa fa-pencil"></i> Edit' +
                        '</a>' +
                        '</div>' +
                        '<a href="javascript:void(0)" class="btn btn-danger btn-sm btn-disabled delete-report" data-row="'+row+'" data-id="' + cellData + '" role="button">' +
                        '<i class="fa fa-trash-o"></i> Delete' +
                        '</a></div>';
                    $(td).html(html);
                }
            }
        ]
    });
    $('#app-post-comscore-table').on('click', '.report-view', function () {
        show_loader();
        init_progress_loader(2, 'This query might take a few seconds. Please wait ...');
        var url= '/post/comscore/report/view/'+ $(this).attr('data-id');
        var link = document.createElement('a');
        link.href = url;
        link.click();
    });
    $.ajax({
        type: 'GET',
        url: '/post/comscore/list',
        dataType: 'json',
        encode: true,
        success: function (response) {
            app_post_comscore_table.clear();
            app_post_comscore_table.rows.add(response);
            app_post_comscore_table.draw();
        },
        error: function (xhr) {
            ajax_error();
            debug(xhr.responseText);
        }
    });
    $('#app-post-comscore-table').on('click', '.delete-report', function () {
        $.ajax({
            type: 'GET',
            url: '/post/comscore/report/delete/'+  $(this).attr('data-id'),
            dataType: 'json',
            encode: true,
            success: function (response) {
                global_notification('success', 'Report deleted...');
                app_post_comscore_table.row($(this).attr('data-row')).remove().draw();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });
}

// if ($('.report-comscore-content-complety').length) {
//     var rating_total = 0;
//     var rating_diff_total = 0;
//     var last_rating = -1;
//     var tables_to_export_excel='';
//     var htmlx='';
//     var htmlx = '<table  style=";width: 100%;border-top: 1px solid black; border-left: 1px solid black;border-right: 1px solid black;background-color: #373737; ' +
//         ' height: 20px;\n' +
//         '                        margin-left: 0%;\n' +
//         '                        background-color: #373737 !important;\n' +
//         '                        color: whitesmoke !important;\n' +
//         '                        border-bottom: none !important;\n' +
//         '                        font-weight: 600 !important;\n' +
//         '                        font-size: 11px;\n' +
//         '                        line-height: 20px;\n' +
//         '                        text-transform: uppercase;\n' +
//         '                        text-align: center;\n' +
//         '                        cursor: pointer;">' +
//         '<tr><td style="color: white">Station: '+vendor.name+'</td>' +
//         '<td style="color: white">Advertiser: '+advertiser.name+'</td>' +
//         '<td style="color: white"> </td></tr>' +
//         '</table>';
//     $('.report-content-header').html('');
//     $('.report-content-header').html(htmlx);
//     var html='';
//     var html_body='';
//     html+=  '<table style="font-size: 12px; color: black;width: 100%; ">' +
//         '<tr style="background-color: #fce4d6; ">' +
//         '<th colspan="2" style="color: black; "></th>' +
//         '<th colspan="2" style="color: black"></th>' +
//         '<th colspan="4" style="color: black"></th>' +//rate, SL, ISCI, Week
//         '<th colspan="2" style="border-right: 1px solid black; border-left: 1px solid black; color: black"><b>Exp- '+exp+'</b></th>' +//old data,
//         '<th colspan="2" style="border-right: 1px solid black; color: black"><b>'+exp+'</b></th>' +//new data,
//         '</tr>' +
//         '<tr style="background-color: #fce4d6; border-bottom: 1px solid black">' +
//         '<th></th><th style="padding-left:4%; color: black"><b>Time</b></th>' +
//         '<th></th><th style="; color: black"><b>Program</b></th>' +
//         '<th style="color:black"><b>Rate</b></th><th style="color:black"><b>SL</b></th>' +
//         '<th style="color:black"><b>ISCI</b></th><th style="border-right: 1px solid black; color:black"><b>Week</b></th>' +
//         '<th style="color:black"><b>RTG</b></th><th style="border-right: 1px solid black; color:black"><b>CPP</b></th>' +
//         '<th style="color:black"><b>RTG</b></th><th style="border-right: 1px solid black; color:black"><b>CPP</b></th>' +
//         '</tr>' ;
//
//     html_body=  '<table style="font-size: 12px; color: black;width: 100%; ">' +
//         '<tr style="background-color: #fce4d6; ">' +
//         '<th colspan="2" style="color: black; "></th>' +
//         '<th colspan="2" style="color: black"></th>' +
//         '<th colspan="4" style="color: black"></th>' +//rate, SL, ISCI, Week
//         '<th colspan="2" style=" color: black"><b>Exp- '+exp+'</b></th>' +//old data,
//         '<th colspan="2" style=" color: black"><b>'+exp+'</b></th>' +//new data,
//         '</tr>' +
//         '<tr style="background-color: #fce4d6; ">' +
//         '<th></th><th style="padding-left:4%; color: black"><b>Time</b></th>' +
//         '<th></th><th style="; color: black"><b>Program</b></th>' +
//         '<th style="color:black"><b>Rate</b></th><th style="color:black"><b>SL</b></th>' +
//         '<th style="color:black"><b>ISCI</b></th><th style=" color:black"><b>Week</b></th>' +
//         '<th style="color:black"><b>RTG</b></th><th style=" color:black"><b>CPP</b></th>' +
//         '<th style="color:black"><b>RTG</b></th><th style="color:black"><b>CPP</b></th>' +
//         '</tr>' ;
//     var spots=0;
//     var total_gross=0;
//
//     for(var date in data) {
//         html += '<tr style="background-color:#eaeaea">' +
//             '<td style="padding-left: 1% ;color:black"colspan="2"><b>'+dates_of_week[date]+'</b>  <b>'+moment(date).format('MM/DD/YYYY')+'</b></td>' +
//             '<td colspan="2"></td>' +
//             '<td colspan="4" style="border-right: 1px solid black"></td>' +
//             '<td colspan="2" style="border-right: 1px solid black"></td>' +
//             '<td colspan="2" style="border-right: 1px solid black"></td>' +
//             '</tr>' ;
//
//         html_body+='<tr style="background-color:#eaeaea">' +
//             '<td style="padding-left: 1% ;color:black"colspan="2"><b>'+dates_of_week[date]+'</b>  <b>'+moment(date).format('MM/DD/YYYY')+'</b></td>' +
//             '<td colspan="2"></td>' +
//             '<td colspan="4"></td>' +
//             '<td colspan="2"></td>' +
//             '<td colspan="2"></td>' +
//             '</tr>' ;
//
//         var x=1;
//         for(var i in data[date]) {
//             spots++;
//             total_gross+=parseFloat(data[date][i].rate);
//             var string = '';
//             if (x == data[date].length) {
//                 x = 0;
//                 string = 'border-bottom:1px dotted grey';
//             }
//             html += '<tr style="">' +
//                 '<td colspan="3" style="padding-left: 4%; ' + string + ' ">' + data[date][i].run_time + ' ' + data[date][i].line_days + ' ' + data[date][i].line_time + '</td>' +
//                 '<td  style=" ;' + string + '">' + data[date][i].program + ' </td>' +
//                 '<td  style=";' + string + '">$' + data[date][i].rate + ' </td>' +
//                 '<td  style=" ;' + string + '">:' + data[date][i].length + ' </td>' +
//                 '<td  style=";' + string + '">' + data[date][i].copy_id + ' </td>' +
//                 '<td  style="border-right: 1px solid black; ' + string + '">' + moment(data[date][i].week).format('MM/DD/YYYY') + ' </td>' +
//                 '<td  style="; ' + string + '">' + data[date][i].old_rating.toFixed(1) + ' </td>' +
//                 '<td  style=" ;border-right: 1px solid black;' + string + '">$' + data[date][i].old_cpp.toFixed(2) + ' </td>' +
//                 '<td  style=";' + string + '">' + data[date][i].real_rating.toFixed(1) + ' </td>' +
//                 '<td  style="; border-right: 1px solid black;' + string + '">$' + data[date][i].real_cpp.toFixed(2) + ' </td>' +
//                 '</tr>';
//             rating_total += (!isNaN(parseFloat(data[date][i].real_rating.toFixed(1))) ? parseFloat(data[date][i].real_rating.toFixed(1)) : 0);
//             if(last_rating !== -1)
//                 rating_diff_total += (!isNaN(parseFloat(data[date][i].real_rating.toFixed(1))) ? Math.abs(parseFloat(data[date][i].real_rating.toFixed(1)) - last_rating) : 0);
//             last_rating = (!isNaN(parseFloat(data[date][i].real_rating.toFixed(1))) ? parseFloat(data[date][i].real_rating.toFixed(1)) : 0);
//             html_body+='<tr style="">' +
//                 '<td colspan="3" style="padding-left: 4%; ' + string + ' ">' + data[date][i].run_time + ' ' + data[date][i].line_days + ' ' + data[date][i].line_time + '</td>' +
//                 '<td  style=" ;' + string + '">' + data[date][i].program + ' </td>' +
//                 '<td  style=";' + string + '">$' + data[date][i].rate + ' </td>' +
//                 '<td  style=" ;' + string + '">:' + data[date][i].length + ' </td>' +
//                 '<td  style=";' + string + '">' + data[date][i].copy_id + ' </td>' +
//                 '<td  style="' + string + '">' + moment(data[date][i].week).format('MM/DD/YYYY') + ' </td>' +
//                 '<td  style="; ' + string + '">' + data[date][i].old_rating.toFixed(1) + ' </td>' +
//                 '<td  style=" ' + string + '">$' + data[date][i].old_cpp.toFixed(2) + ' </td>' +
//                 '<td  style=";' + string + '">' + data[date][i].real_rating.toFixed(1) + ' </td>' +
//                 '<td  style="; ' + string + '">$' + data[date][i].real_cpp.toFixed(2) + ' </td>' +
//                 '</tr>';
//             x++;
//         }
//
//     }
//     html+=  '</table>';
//     html_body+=  '</table>';
//     var html_totals='';
//     var html_totals_send='';
//     var total_cpp=0;
//     if(total_grp > 0)
//         total_cpp=total_gross/total_grp;
//     var difference= parseFloat(0.0);
//     var sig=' ';
//     if(total_grp > old_grp) {
//         difference = parseFloat(total_grp - old_grp).toFixed(1);
//         sig='+';
//     }
//     else if(total_grp < old_grp) {
//         difference = parseFloat(old_grp - total_grp).toFixed(1);
//         sig='-';
//     }
//     var perc=100;
//     if(old_grp > 0)
//         perc= (total_grp * 100)/old_grp;
//
//     var total_reach_round = (spots > 0 ? (1 - Math.pow((1 - ((spots > 0) ? (rating_total/spots) : 0)/100), spots)) * 75 : 0).toFixed(1);
//     var total_reach = (spots > 0 ? (1 - Math.pow((1 - ((spots > 0) ? (rating_total/spots) : 0)/100), spots)) * 75 : 0);
//     console.log('reach', total_reach);
//     console.log('reach_round', total_reach_round);
//
//     html_totals+='<table style="font-size: 10px; color: black;width: 100%;border: none "><tr><th colspan="10"></th></tr></table><table style="font-size: 10px; color: black;width: 100%;border: none ">' +
//         '<tr style="border-bottom: 1px solid black;color: black; background-color: #fce4d6 "><th style="border-right: 1px solid black; color:black" colspan="7"><b>Delivery Totals</b></th>' +
//         '<th  style="border-right: 1px solid black; color: black; " colspan="2"><b>Post Delivery</b></th><th style="color: black "><b>GRPs</b></th></tr>' +
//         '<tr style="border-bottom: 1px solid black; color: black;  background-color: #fce4d6"><th style="border-right: 1px solid black;color: black" ><b>Demo</b></th>' +
//         '<th style="border-right: 1px solid black;color: black "><b>Spots</b></th><th style="border-right: 1px solid black;color: black "><b>Reach</b></th>' +
//         '<th style="border-right: 1px solid black;color: black "><b>Freq</b></th><th style="border-right: 1px solid black;color: black "><b>GRP</b></th>' +
//         '<th style="border-right: 1px solid black;color: black "><b>CPP</b></th>' +
//         '<th style="border-right: 1px solid black;color: black "><b>Total</b></th>' +
//         '<th colspan="2" style="border-right: 1px solid black;color: black "><b>Adjusted</b></th>' +
//         '<th style="border-right: 1px solid black;color: black "><b>Delivered</b></th>' +
//         '</tr>' +
//         '<br> <th>'+demo+'</th>' +
//         '<th>'+spots+'</th>' +
//         '<th>' + total_reach_round + '</th>' +
//         '<th>' + (total_reach > 0 ? ((total_grp * 1.05) / (total_reach * 0.95)).toFixed(1) : '0.0') + '</th>' +
//         '<th>'+total_grp.toFixed(1)+'</th>' +
//         '<th>$'+total_cpp.toFixed(2)+'</th>' +
//         '<th>$'+total_gross.toFixed(2)+'</th>' +
//         '<th colspan="2">'+old_grp.toFixed(1)+' GRP Goal</br> '+sig+''+ difference+' Difference </br> '+ perc.toFixed(1)+'% Delivered</th>' +
//         '<th>'+total_grp.toFixed(1)+'</th>' +
//         '</tr>' ;
//     html_totals+='</table>';
//     html_totals_send+='<table style="font-size: 10px; color: black;width: 100%;border: none "><tr><th colspan="10"></th></tr></table><table style="font-size: 10px; color: black;width: 100%;border: none ">' +
//         '<tr style="color: black; background-color: #fce4d6 "><th style="; color:black" colspan="7"><b>Delivery Totals</b></th>' +
//         '<th  style=" color: black; " colspan="2"><b>Post Delivery</b></th><th style="color: black "><b>GRPs</b></th></tr>' +
//         '<tr style=" color: black;  background-color: #fce4d6"><th style=";color: black" ><b>Demo</b></th>' +
//         '<th style=";color: black "><b>Spots</b></th><th style=";color: black "><b>Reach</b></th>' +
//         '<th style=";color: black "><b>Freq</b></th><th style=";color: black "><b>GRP</b></th>' +
//         '<th style=";color: black "><b>CPP</b></th>' +
//         '<th style=";color: black "><b>Total</b></th>' +
//         '<th colspan="2" style=";color: black "><b>Adjusted</b></th>' +
//         '<th style=";color: black "><b>Delivered</b></th>' +
//         '</tr>' +
//         '<br> <th>'+demo+'</th>' +
//         '<th>'+spots+'</th>' +
//         '<th>' + total_reach_round + '</th>' +
//         '<th>' + (total_reach > 0 ? ((total_grp * 1.05) / (total_reach * 0.95)).toFixed(1) : '0.0') + '</th>' +
//         '<th>'+total_grp.toFixed(1)+'</th>' +
//         '<th>$'+total_cpp.toFixed(2)+'</th>' +
//         '<th>$'+total_gross.toFixed(2)+'</th>' +
//         '<th colspan="2">'+old_grp.toFixed(1)+' GRP Goal</br> '+sig+''+ difference+' Difference </br> '+ perc.toFixed(1)+'% Delivered</th>' +
//         '<th>'+total_grp.toFixed(1)+'</th>' +
//         '</tr></table>' ;
//
//     $('.report-content').html('');
//     $('.report-content').html(html);
//     $('.media-totals-wrapper-demo-analisis').html('');
//     $('.media-totals-wrapper-demo-analisis').html(html_totals);
//
//     $('#html_body').val(html_body);
//     $('#html_totals').val(html_totals_send);
//     $('#report_id').val(report.id);
//     $('#total_grp').val(total_grp);
//     $('#total_imp').val(total_imp);
//     $('#old_grp').val(old_grp);
//     $('#dates_of_week').val(dates_of_week);
//     $('#data_got').val(data_got);
//
//     tables_to_export_excel+=' <table style="width: 100%; font-size: 12px"><tr><td></td></tr></table>' +
//         '<table style="width: 100%; font-size: 12px; border-top: 1px solid black; border-bottom: 1px solid black; "> <tr>'+
//         '<td colspan="2" style="width: 15%; text-align: left">Station: </td>'+
//         '<td colspan="4" style="width: 60%;">'+vendor.name+' </td>'+
//         '<td colspan="2"></td> '+
//         '<td colspan="4" style=" border-bottom: 1px double #678CB1; text-align: center" >Station Contact </td>'+
//         '</tr>'+
//         '<tr>'+
//         '<td colspan="2" style="width: 15%; text-align: left">Advertiser: </td>'+
//         '<td colspan="4" style="width: 60%;">'+advertiser.name+' </td>'+
//         '<td colspan="2"></td> '+
//         '<td colspan="4">  Name: '+contact.contact_name+'</td>'+
//
//         '</tr>'+
//         '<tr>'+
//         '<td colspan="2" style="width: 15%; text-align: left">Buyer: </td>'+
//         '<td colspan="4" style="width: 60%;">'+user.name+' </td>'+
//         '<td colspan="2"></td> '+
//         '<td colspan="4"> Phone: '+contact.phone+' </td>'+
//         '</tr>'+
//         '<tr>'+
//         '<td colspan="2" style="width: 15%; text-align: left">Post Dates: </td>'+
//         '<td colspan="4" style="width: 60%;">'+moment(campaign.start).format('Y/M/D')+' - '+moment(campaign.end).format('Y/M/D')+' </td>'+
//         '<td colspan="2"></td> '+
//         '<td colspan="4">  Fax: '+contact.fax+'</td>'+
//         '</tr>'+
//         '<tr>'+
//         '<td colspan="2" style="width: 15%; text-align: left">Agency: </td>'+
//         '<td colspan="4" style="width: 60%;">'+agency.name+' </td>'+
//         '<td colspan="2"></td> '+
//         '<td colspan="4">  Email: '+contact.email+'</td>'+
//         '</tr>'+
//         '<tr>'+
//         '<td colspan="2" style="width: 15%; text-align: left">Estimate #: </td>'+
//         '<td colspan="4" style="width: 60%; ">'+campaign.estimate_number+' </td>'+
//         '<td colspan="6"></td> '+
//         '</tr>'+
//         '</table><table style="width: 100%; font-size: 12px"><tr><td></td></tr></table>';
//     tables_to_export_excel+=html_body;
//     tables_to_export_excel+=html_totals;
//
//     $('.delivery-totals').on('click', function () {
//         if (!$(this).hasClass('expanded')) {
//             $('.report-content').css('height', '450px');
//             $('.media-totals-wrapper-demo-analisis').css('height', 'auto').show();
//             $(this).addClass('expanded');
//             $(this).find('i').removeClass('fa-angle-double-up').addClass('fa-angle-double-down');
//         } else {
//             $('.report-content').css('height', '550px');
//             $('.media-totals-wrapper-demo-analisis').css('height', '0').hide();
//             $(this).removeClass('expanded');
//             $(this).find('i').removeClass('fa-angle-double-down').addClass('fa-angle-double-up');
//         }
//
//     });
//     $('.export-pdf').on('click', function () {
//         if($('#html_totals').val().indexOf("LEGAL DISCLAIMER") === -1)
//             $('#html_totals').val($('#html_totals').val() + '<br/><br/><table cellspacing="0" style="width: 100%;"><tbody><tr><td colspan="7" style="background-color: #F8AB91; font-weight: bold;padding:2px 2px 2px 6px;width: 100%;">LEGAL DISCLAIMER</td></tr><tr><td colspan="7" style="padding:2px 2px 2px 6px;width: 100%;background-color: #fce4d6">All metrics contained in this document are calculations of GaleForce Digital Technologies and have not been verified by Comscore.</td></tr></tbody></table>')
//         $('#export_pdf_post_comscore').submit();
//
//     });
//
//     $('.export-excel').on('click', function () {
//         if(tables_to_export_excel.indexOf("LEGAL DISCLAIMER") === -1)
//             tables_to_export_excel += '<br/><br/><table cellspacing="0" style="width: 100%;"><tbody><tr><td colspan="7" style="background-color: #F8AB91; font-weight: bold;padding:2px 2px 2px 6px;width: 100%;">LEGAL DISCLAIMER</td></tr><tr><td colspan="7" style="padding:2px 2px 2px 6px;width: 100%;background-color: #fce4d6">All metrics contained in this document are calculations of GaleForce Digital Technologies and have not been verified by Comscore.</td></tr></tbody></table>'
//         var url='data:application/vnd.ms-excel,' + encodeURIComponent(tables_to_export_excel);
//         location.href=url;
//         return false;
//     });
//
// }


